import { useState, useEffect } from "react";

const REASONS = [
  { sub: "특별공급", title: "한강뷰 프리미엄 세대" },
  { sub: "19세 이상 누구나", title: "자격조건 ZERO" },
  { sub: "안전성 확보", title: "HUG 보증보험" },
  { sub: "세금부담 제로", title: "주택수 미포함" },
  { sub: "10년 장기거주 후", title: "분양전환" },
];

export default function DailyPopup() {
  const [isOpen, setIsOpen] = useState(false);
  const [dontShowToday, setDontShowToday] = useState(false);

  useEffect(() => {
    const hidden = localStorage.getItem("popup_hidden_date");
    const today = new Date().toDateString();
    if (hidden !== today) {
      const timer = setTimeout(() => setIsOpen(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    if (dontShowToday) {
      localStorage.setItem("popup_hidden_date", new Date().toDateString());
    }
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[70] bg-black/60 flex items-center justify-center px-4">
      <div
        className="bg-white rounded-2xl max-w-sm w-full overflow-hidden animate-fade-up"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="relative bg-[#1a2320] px-6 pt-8 pb-7 text-center">
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 w-7 h-7 flex items-center justify-center text-white/60 hover:text-white transition-colors cursor-pointer"
            aria-label="닫기"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-close-line text-lg"></i>
            </span>
          </button>
          <p className="text-[#5fb89a] text-xs tracking-[0.2em] font-medium mb-3 uppercase">
            AUVERSONE · SPECIAL
          </p>
          <h2 className="text-white text-2xl font-bold leading-snug">
            놓칠 수 없는<br />
            <span className="text-[#5fb89a]">5가지 이유!</span>
          </h2>
        </div>

        {/* Reasons List */}
        <div className="bg-[#f7f8f6] px-5 py-2">
          {REASONS.map((item, idx) => (
            <div key={idx} className="flex items-center gap-4 py-4 border-b border-[#e8eae6] last:border-b-0">
              <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-full bg-[#5fb89a] text-white font-bold text-sm">
                {idx + 1}
              </div>
              <div>
                <p className="text-[11px] text-[#8a9a8e] mb-0.5">{item.sub}</p>
                <p className="text-[#1a2320] font-bold text-base leading-tight">{item.title}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="px-5 pb-5 pt-4 bg-[#f7f8f6]">
          <button
            onClick={handleClose}
            className="w-full py-4 bg-[#3da882] hover:bg-[#2e9470] text-white font-semibold text-base rounded-xl transition-colors cursor-pointer whitespace-nowrap"
          >
            확인했어요
          </button>
          <div className="flex items-center mt-3 px-1">
            <label className="flex items-center gap-2 cursor-pointer text-xs text-[#8a9a8e]">
              <input
                type="checkbox"
                checked={dontShowToday}
                onChange={(e) => setDontShowToday(e.target.checked)}
                className="w-3.5 h-3.5 cursor-pointer"
              />
              오늘 하루 보지 않기
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}